import type { WidgetLoaders } from '@/data-sources/contract';

import { brandHealthWidgetLoaders } from './brand-health';
import { communityWidgetLoaders } from './community';
import { competitorsWidgetLoaders } from './competitors';
import { influencersWidgetLoaders } from './influencers';
import { mediaWidgetLoaders } from './media';
import { mentionsWidgetLoaders } from './mentions';
import { overviewWidgetLoaders } from './overview';
import { tablesWidgetLoaders } from './tables';
import { withComparison } from './shared';
import { trendsWidgetLoaders } from './trends';

/** Typed as the full map: a widget in the contract without a mock loader fails the build. */
const loaders: WidgetLoaders = {
  ...overviewWidgetLoaders,
  ...brandHealthWidgetLoaders,
  ...communityWidgetLoaders,
  ...competitorsWidgetLoaders,
  ...mediaWidgetLoaders,
  ...mentionsWidgetLoaders,
  ...trendsWidgetLoaders,
  ...influencersWidgetLoaders,
  ...tablesWidgetLoaders,
};

/**
 * The categorical widgets whose payload carries `previous` (`WithPrevious`) —
 * the same payload over the comparison range, for the chart tooltip.
 */
export const mockWidgetLoaders: WidgetLoaders = {
  ...loaders,
  'mentions-by-platform': withComparison(loaders['mentions-by-platform']),
  'keyword-sentiment': withComparison(loaders['keyword-sentiment']),
  'trending-keywords': withComparison(loaders['trending-keywords']),
  'trending-topics': withComparison(loaders['trending-topics']),
  'top-media-outlets': withComparison(loaders['top-media-outlets']),
  'engagement-by-type': withComparison(loaders['engagement-by-type']),
  'topic-sentiment-split': withComparison(loaders['topic-sentiment-split']),
  'competitor-sentiment-comparison': withComparison(loaders['competitor-sentiment-comparison']),
  'seeded-vs-organic': withComparison(loaders['seeded-vs-organic']),
  'top-communities-by-mention': withComparison(loaders['top-communities-by-mention']),
  'top-communities-by-sentiment': withComparison(loaders['top-communities-by-sentiment']),
  'top-individual-voices': withComparison(loaders['top-individual-voices']),
  'community-topics': withComparison(loaders['community-topics']),
  'complaints-by-division': withComparison(loaders['complaints-by-division']),
  'audience-age-and-gender': withComparison(loaders['audience-age-and-gender']),
};
